import PropTypes from "prop-types";
import React from "react";
import FormItem from "antd/lib/form/FormItem";
import {
  TitleWrapper,
  InputWrapperDrop,
  NoResultsWrap,
  SelectOptionWrapper,
  SelectOptionMainWrapper,
  TitleMarginTop,
  SelectdropwownStyles,
  WrapLabel,
} from "../styles";
import { Select, Form } from 'antd';


const SelectComponent = props => {
    const { getFieldDecorator } = props.form;
  return (
    <div>
      <WrapLabel>
      <FormItem
        colon={false}
        label={(props.showTitle === false) ? '':
          <TitleMarginTop>
            <TitleWrapper>{props.title}</TitleWrapper>
            </TitleMarginTop>
        }
      >
        {getFieldDecorator(props.id, {
          rules: [{ type: "string" }]
        })(
          <InputWrapperDrop>
            <SelectOptionMainWrapper>
              <SelectdropwownStyles>
                <div
                  id={props.id}
                  style={{ position: "relative" }}
                >
                  <Select
                    role={false}
                    onBlur={props.handleBlur}
                    optionFilterProp="children"
                    disabled={props.disabled}
                    filterOption={(input, option) => {                      
                      return option.props.value
                        .toLowerCase()
                        .startsWith(input.toLowerCase())}}
                    getPopupContainer={() => document.getElementById(props.id)}
                    onSearch={props.handleChange}
                    onChange={props.handleChange}
                    defaultActiveFirstOption={false}
                    showSearch={props.isSearch === "true" ? true: false}
                    notFoundContent={<NoResultsWrap>No results</NoResultsWrap>}
                    value={props.value}
                    placeholder={props.placeholderText}
                    defaultValue={props.default ? props.default : undefined}
                    role={false}
                  >
                    {props.dropDownvalues
                      ? props.dropDownvalues.map((freq,index) => (
                          <Select.Option value={freq.desc} key={freq.desc+index}>
                            <SelectOptionWrapper>
                              {freq.desc}
                            </SelectOptionWrapper>
                          </Select.Option>
                        ))
                      : null}
                  </Select>
                </div>
              </SelectdropwownStyles>
            </SelectOptionMainWrapper>
          </InputWrapperDrop>
        )}
      </FormItem>
      </WrapLabel>
    </div>
  );
};

SelectComponent.propTypes = {
  default: PropTypes.string,
  disabled: PropTypes.any,
  dropDownvalues: PropTypes.arrayOf(PropTypes.shape({
    desc: PropTypes.string,
    value: PropTypes.string
  })),
  form: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isSearch: PropTypes.string,
  placeholderText: PropTypes.string,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any),PropTypes.string])  
};

const WrappedSelectComponent = Form.create({ name: "select" })(SelectComponent);

export default WrappedSelectComponent;
